<template>
  <ul class="result-list">
    <li v-for="(provider, index) in providers" :key="index">
      <div class="result-item">
        <h2 class="header capitalize">
          <span v-if="provider.firstName">{{ provider.firstName.toLowerCase() }} </span>
          <span v-if="provider.middleName">{{ provider.middleName.toLowerCase() }} </span>
          <span v-if="provider.lastName">{{ provider.lastName.toLowerCase() }}</span> ,
            {{ provider.title }}
        </h2>
        <!-- TODO: is it a good idea to pick the first entry?  -->
        <provider-bio :provider="provider" :specialty="getFirstSpecialtyName(provider)" :keywords="keywords || []"></provider-bio>
      </div>
      <router-link :to="{ name: 'ProviderNavigation', params: { specialty: getFirstSpecialtyLink(provider), id: provider.id } }" class="result-item-link">
        View profile <font-awesome-icon :icon="['fas', 'arrow-right']" />
      </router-link>
    </li>
  </ul>
</template>

<script>
  import ProviderBio from '../providers/ProviderBio';

  export default {
    name: "SearchProviderResults",
    props: {
      providers: Array,
      keywords: Array,
    },
    components: {
      'provider-bio': ProviderBio,
    },
    methods: {
      getSpecialtyLink(specialty) {
        return specialty.toLowerCase().replace(/\s/g, '-');
      },
      getFirstSpecialtyName(provider) {
        if (provider.specialties && provider.specialties.length > 0 && provider.specialties[0].name) {
          return provider.specialties[0].name;
        }
        return 'General Practice'; // fallback
      },
      getFirstSpecialtyLink(provider) {
        const specialtyName = this.getFirstSpecialtyName(provider);
        return this.getSpecialtyLink(specialtyName);
      },
    }
  }
</script>

<style scoped lang="scss">
  .result-list {
    width: 700px;
  }
  .result-item {
    border: 1px solid lightgray;
    border-radius: 5px;
    margin: 2em auto 0;
    text-align: left;
  }
  .result-item:first-child {
    margin-top: 1.0em;
  }
  .header {
    text-align: center;
    color: #fff;
    font-size: 1.2em;
    padding: 5px 0;
    background-color: #007bff;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .result-item-link {
    display: block;
    text-align: right;
    font-size: 0.85em;
  }

  @media only screen and (max-width: 768px) {
    .result-list {
      width: 100%;
    }
  }
</style>